



































































































import RespondecoAboutUs from '@/business/home/components/about-us.vue'
import RespondecoFooter from '@/main/footer.vue'
import RespondecoHeader from '@/main/header/header.vue'
import RespondecoMeaning from '@/business/home/components/meaning.vue'

import Spinner from 'vue-simple-spinner'

import Component from 'vue-class-component'
import { PortfolioModel } from '@/shared/models/portfolio-model'
import { Injector } from '@/config/dependency-injection'
import { HomeModule } from '@/business/home/store/home-module'
import { SET_HOME } from '@/business/home/store/types'

import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import RespondecoPortfolioItem from '@/shared/components/respondeco-portfolio-item.vue'
import { BaseComponent } from '@/shared/components/base-component'
import { HomeState } from '@/business/home/store/home-state'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import VueTypedJs from '@/shared/components/vue-typed-js/vue-typed-js.vue'

@Component({
  components: {
    VueTypedJs,
    RespondecoLoadingIndicator,
    UnifyButton,
    RespondecoAboutUs,
    RespondecoFooter,
    RespondecoHeader,
    RespondecoMeaning,
    RespondecoPortfolioItem,
    Spinner,
    UnifyHero,
    UnifyPage,
  },
})
export default class Home extends BaseComponent {
  public organisations: PortfolioModel[] = []
  public offers: PortfolioModel[] = []

  private homeModule = Injector.get(HomeModule)

  public get homeState(): HomeState {
    return this.homeModule.data
  }

  public get loading() {
    return this.loaderHelper.isLoading(SET_HOME)
  }

  public created() {
    this.metaService.updateDocumentTitle('home')

    this.homeModule.fetchHomeData()
  }
}
